<template>
    <ion-item class="message ion-no-padding" button>
        <ion-avatar slot="start" style="display: flex; align-items: center;" v-show="!$root.isMobileOrSmall">
            <ion-icon size="large" color="medium" :ios="userIsSender ? 'arrow-forward-circle': 'arrow-back-circle'" :md="userIsSender ? 'arrow-forward-circle': 'arrow-back-circle'"></ion-icon>
        </ion-avatar>
        <ion-label>
            <ion-item @click="openMessage(message.id)" lines="none" class="ion-no-padding">
                <ion-label>
                    <h2>
                        <span v-for="(recipient, i) in message.recipients" v-bind:key="`${i}-${recipient.id}`" outline color="primary">{{ recipient.email }}</span>
                    </h2>
                    <h3>{{ message.subject }}</h3>
                </ion-label>
                <ion-badge slot="end" ion-no-padding>{{ message.sent_at_short }}</ion-badge>
            </ion-item>
            <ion-item v-show="!$root.isMobileOrSmall" lines="none" v-if="message.attachments && message.attachments.length">
                <attachment v-for="(attachment, i) in message.attachments" v-bind:key="`${i}-${attachment.id}`" :attachment="attachment" outline color="primary"></attachment>
            </ion-item>
        </ion-label>
    </ion-item>
</template>

<script>
    import Attachment from "../Attachment.vue";

    export default {
        components: {Attachment},
        props: ['message'],
        methods: {
            openMessage(id) {
                this.$router.push({name: 'message', params: {id}});
            },
        },
        computed: {
            userIsSender() {
                return this.message && this.message.sender && this.$store.getters.authed && this.message.sender.id === this.$store.getters.user.id;
            },
        },
    }
</script>
